import React, {Component} from 'react';
import ReactPlayer from 'react-player'

class ChromeVideoApp extends Component {

    render() {
        return (
            <div className='player-wrapper'>
                <ReactPlayer
                    className='react-player fixed-bottom'
                    url='/_core/assets/themes/transcription/assets/video/chrome.mp4'
                    width='100%'
                    height='100%'
                    controls = {true}
                />
            </div>
        )
    }
}

export default ChromeVideoApp;